import type {ContentType as SweetContentType} from 'sweet-types';

export type contentType = SweetContentType;
export interface ContentType {
  name: string;
  pluralName: string;
  icon: string;
  iconAlt?: string;
}

export const pureGetContentType = (
  ct: contentType,
  gt: (...args: any[]) => string
): ContentType => {
  switch (ct) {
    case 'procedure':
      return {
        name: gt('procedure'),
        pluralName: gt('procedures'),
        icon: 'far fa-file',
      };

    case 'procedureversion':
      return {
        name: gt('procedure version'),
        pluralName: gt('procedure versions'),
        icon: 'far fa-clock',
      };
    case 'proceduregroup':
      return {
        name: gt('process'),
        pluralName: gt('processes'),
        icon: 'far fa-copy',
      };
    case 'taskinstance':
      return {
        name: gt('task'),
        pluralName: gt('tasks'),
        icon: 'fa fa-tasks',
      };
    case 'tasktemplate':
      return {
        name: gt('task'),
        pluralName: gt('tasks'),
        icon: 'fa fa-tasks',
      };
    case 'team':
      return {
        name: gt('team'),
        pluralName: gt('teams'),
        icon: 'fa fa-users',
      };
    case 'user':
      return {
        name: gt('member'),
        pluralName: gt('members'),
        icon: 'fa fa-user',
      };
    case 'role':
      return {
        name: gt('role'),
        pluralName: gt('roles'),
        icon: 'fa fa-user-tag',
      };
    case 'accountprofile':
      return {
        name: gt('account'),
        pluralName: gt('accounts'),
        icon: 'fa fa-coffee',
      };
    case 'policy':
      return {
        name: gt('policy'),
        pluralName: gt('policies'),
        icon: 'fa fa-umbrella',
      };
    case 'policyversion':
      return {
        name: gt('policy version'),
        pluralName: gt('policy versions'),
        icon: 'far fa-clock',
      };
    case 'quiz':
      return {
        name: gt('quiz'),
        pluralName: gt('quizzes'),
        icon: 'far fa-check',
      };
    case 'quizversion':
      return {
        name: gt('quiz version'),
        pluralName: gt('quiz versions'),
        icon: 'far fa-clock',
      };
    case 'tag':
      return {
        name: gt('tag'),
        pluralName: gt('tags'),
        icon: 'fa fa-tag',
      };
    case 'folder':
      return {
        name: 'folder',
        pluralName: 'folders',
        icon: 'far fa-folder',
        iconAlt: 'far fa-folder-open',
      };

    case 'knowledgebase':
      return {
        name: gt('knowledge base'),
        pluralName: gt('knowledge bases'),
        icon: 'far fa-book-open',
      };
    case 'article':
      return {
        name: gt('article'),
        pluralName: gt('articles'),
        icon: 'far fa-book',
      };
    case 'document':
      return {
        name: gt('document'),
        pluralName: gt('documents'),
        icon: 'far fa-file-alt',
      };
    case 'lane':
      return {
        name: gt('lane'),
        pluralName: gt('lanes'),
        icon: 'fas fa-road',
      };
    case 'attempt':
      return {
        name: gt('attempt'),
        pluralName: gt('attempts'),
        icon: 'fa fa-check-square',
      };
    case 'processversion':
      return {
        name: gt('process version'),
        pluralName: gt('process versions'),
        icon: 'far fa-clock',
      };
    case 'template':
      return {
        name: gt('template'),
        pluralName: gt('templates'),
        icon: 'fa fa-file-export',
      };
    default: {
      return {name: '', pluralName: '', icon: ''};
    }
  }
};
